import { h } from "preact";
import { useState } from "preact/hooks";
import { sortBy, uniq } from "lodash";

import { classNames } from "../helpers";

import Checkbox from "./Checkbox.jsx";
import List from "./List.jsx";
import ListItem from "./ListItem.jsx";
import TextField from "./TextField.jsx";

export default function UserSelectorPullout({
  close,
  items,
  placeholder,
  onChange,
  selected,
  ...props
}) {
  const [search, setSearch] = useState("");

  const filteredUsers = sortBy(
    search
      ? items.filter(
          (user) => (user.name || "").toLowerCase().indexOf(search) > -1
        )
      : items,
    (user) => (user.name || "").toLowerCase()
  );

  function handleSearchKeyPress(event) {
    setSearch(event.target.value.toLowerCase());
  }

  function handleItemClick(event, user) {
    event.preventDefault();
    if (!onChange) return;

    if (selected.find((id) => id === user.id)) {
      onChange(selected.filter((id) => id !== user.id));
    } else {
      onChange(uniq([...selected, user.id]));
    }
  }

  function handleItemChanged(event, user) {
    if (!onChange) return;

    if (event.target.checked) {
      onChange(uniq([...selected, user.id]));
    } else {
      onChange(selected.filter((id) => id !== user.id));
    }
  }

  return (
    <div {...props} class={classNames("user-selector__pullout", props.class)}>
      <TextField
        slim
        placeholder={placeholder}
        onChange={handleSearchKeyPress}
      />

      <div class="user-selector__pullout__content">
        <List>
          {filteredUsers.map((user) => (
            <ListItem
              key={user.id}
              onClick={(event) => handleItemClick(event, user)}
              iconFront={
                <Checkbox
                  class="mr-8 p-0 pt-4"
                  key={selected.find((id) => id === user.id)}
                  checked={selected.find((id) => id === user.id)}
                  onChange={(event) => handleItemChanged(event, user)}
                />
              }
            >
              <div class="t-body4">{user.name}</div>
            </ListItem>
          ))}
        </List>
      </div>
    </div>
  );
}
